module.exports = __webpack_public_path__ + "img/鸿云恒达LOGO-03.bf0bd0d9.png";